import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Typo, TypoCreate } from "@/model";
import typoRepository from "@/repository/typoRepository";
import { typoQueryKeys } from "./keys";


export const useCreateTypo = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Typo, AxiosError, TypoCreate>({
        mutationKey: ["typo", "agent", agentId, "create"],
        mutationFn: async (body: TypoCreate) => {
            try {
                const { data } = await typoRepository.create(agentId,body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: typoQueryKeys.all(agentId)
            });
        }
    });
};
